import { collection, getDocs, query, where } from "firebase/firestore";
import { db } from "../../firebase";

const getAllPropertiesCountForBusiness = async (bid) => {
  try {
    const PropertiesCollection = collection(db, "properties");

    let q = query(
      PropertiesCollection,
      where("bid", "==", bid),
      where("is_deleted", "==", false)
    );

    const PropertiesSnapshot = await getDocs(q);

    const count = PropertiesSnapshot.size;

    return count;
  } catch (error) {
    console.log(error);
    return 0;
  }
};

export default getAllPropertiesCountForBusiness;
